import { Tooltip, TooltipProps } from "@mui/material";
import classNames from "classnames";
import styles from "./styles.module.css";

interface Props extends TooltipProps {
  offsets?: number[];
  className?: string;
}

export const AppTooltip = ({ offsets, className, ...rest }: Props) => {
  const cls = classNames(styles["app-tooltip"], className);

  return (
    <Tooltip
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: offsets,
              },
            },
          ],
        },
      }}
      classes={{ tooltip: styles["app-tooltip"] }}
      className={cls}
      {...rest}
    >
      {rest.children}
    </Tooltip>
  );
};
